import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HowItWorksNavComponent} from './view/how-it-works-nav.component';
import {FlexLayoutModule, FlexModule} from '@angular/flex-layout';
import {HowItWorksNavMobileComponent} from './mobile/how-it-works-nav-mobile.component';
import {HowItWorksNavDesktopComponent} from './desktop/how-it-works-nav-desktop.component';
import {RouterModule} from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    RouterModule,
  ],
  declarations: [
    HowItWorksNavComponent,
    HowItWorksNavMobileComponent,
    HowItWorksNavDesktopComponent,
  ],
  exports: [HowItWorksNavComponent],
})
export class HowItWorksNavModule {
}
